<template>
  <q-card class="full-width" flat bordered>
    <q-card-section>
      <div class="row items-center justify-between">
        <div class="row q-gutter-x-sm">
          <q-avatar color="primary" text-color="white" size="32px">
            {{ name.split(' ')[0][0] + name.split(' ')[1][0] }}</q-avatar
          >
          <div class="text-h5">
            <i v-for="i in 5" :key="i" class="material-icons text-yellow-8"> star_rate </i>
          </div>
        </div>
        <div style="padding-top: 4px">
          <b>{{ name }}</b>
        </div>
      </div>
      <div class="q-mt-md">
        {{ quote }}
      </div>
    </q-card-section>
  </q-card>
</template>
<script lang="ts">
export default {
  name: 'QuoteCard',
  props: {
    quote: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
}
</script>
